<div class="vgauge-size vgauge-size-inner">
    <ngx-charts-heat-map *ngIf="init" [scheme]="chartOptions.colorScheme" [results]="hmapData"
        [gradient]="chartOptions.gradient" [xAxis]="chartOptions.showXAxis" [yAxis]="chartOptions.showYAxis"
        [legend]="chartOptions.showLegend" [showXAxisLabel]="chartOptions.showXAxisLabel"
        [showYAxisLabel]="chartOptions.showYAxisLabel" [xAxisLabel]="chartOptions.xAxisLabel"
        [yAxisLabel]="chartOptions.yAxisLabel" (select)="onSelect($event)" [view]="chartOptions.view"
        [tooltipDisabled]="!chartOptions.tooltip" [class]="chartClass">
    </ngx-charts-heat-map>
</div>